"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var chevron_up_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_up"));
var chevron_down_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_down"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftTypography_1 = __importDefault(require("../LftTypography"));
var S = __importStar(require("./LftAccordion.styles"));
var LftAccordion = function (_a) {
    var _b, _c;
    var _d = _a.bgColor, bgColor = _d === void 0 ? false : _d, children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, id = _a.id, text = _a.text, title = _a.title, lftCollapse = _a.lftCollapse, _e = _a.opened, opened = _e === void 0 ? false : _e, variant = _a.variant, size = _a.size;
    var _f = (0, react_1.useState)(opened), accordionOpened = _f[0], setAccordionOpened = _f[1];
    var _handleClick = function () {
        var status = !accordionOpened;
        setAccordionOpened(status);
        lftCollapse && lftCollapse({ opened: status });
    };
    (0, react_1.useEffect)(function () {
        setAccordionOpened(opened);
    }, [opened]);
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' &&
                (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf('localhost')) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf('dev')) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "accordion_" + dataElement;
        }
    }
    return ((0, jsx_runtime_1.jsxs)(S.AccordionStyled, __assign({ bgColor: bgColor, "data-lift": "lft-accordion", "data-testid": dataTestId ? dataTestId : id && id, "data-info": dataInfo, "data-element": dataElement, id: id }, { children: [(0, jsx_runtime_1.jsx)(S.AccordionButtonStyled, __assign({ onClick: _handleClick, bgColor: bgColor, variant: variant, opened: accordionOpened }, { children: (0, jsx_runtime_1.jsxs)(S.AccordionTitleStyled, __assign({ bgColor: bgColor, "aria-expanded": opened, "data-lift": 'lft-accordion-title', variant: variant, opened: accordionOpened, size: size }, { children: [title, (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: accordionOpened ? chevron_up_1.default : chevron_down_1.default, size: "md", "data-lift": 'lft-accordion-icon' }, void 0)] }), void 0) }), void 0), !!accordionOpened && ((0, jsx_runtime_1.jsxs)(S.AccordionContentStyled, __assign({ text: text, "aria-labelledby": id, bgColor: bgColor, opened: accordionOpened, variant: variant, role: "region" }, { children: [text && ((0, jsx_runtime_1.jsx)(LftTypography_1.default, __assign({ bgColor: bgColor, component: "paragraph", size: "small", className: 'text' }, { children: text }), void 0)), children] }), void 0)), (0, jsx_runtime_1.jsx)(S.AccordionLineStyled, { bgColor: bgColor, variant: variant, opened: accordionOpened }, void 0)] }), void 0));
};
exports.default = LftAccordion;
